import { privacy } from "@redotech/schema-privacy";
import { DateFromDateOrIsoStringSchema } from "@redotech/zod-util/date-schema";
import * as z from "zod";

const MarketplaceNotificationStatusSchema_ = z
  .discriminatedUnion("status", [
    z
      .object({
        status: z.literal("complete").meta({ privacy: privacy.enumOrStatus }),
      })
      .meta({ privacy: privacy.structured }),
    z
      .object({
        status: z.literal("skipped").meta({ privacy: privacy.enumOrStatus }),
      })
      .meta({ privacy: privacy.structured }),
    z
      .object({
        status: z.literal("pending").meta({ privacy: privacy.enumOrStatus }),
        date: DateFromDateOrIsoStringSchema.nullish().meta({
          privacy: privacy.timestamp,
        }),
      })
      .meta({ privacy: privacy.structured }),
    z
      .object({
        status: z.literal("failed").meta({ privacy: privacy.enumOrStatus }),
        actionMessage: z.string().meta({ privacy: privacy.systemErrorText }),
      })
      .meta({ privacy: privacy.structured }),
  ])
  .meta({ privacy: privacy.structured });
export const MarketplaceNotificationStatusSchema: z.ZodType<MarketplaceNotificationStatus> =
  MarketplaceNotificationStatusSchema_;

export type MarketplaceNotificationStatus = z.infer<
  typeof MarketplaceNotificationStatusSchema_
>;

export interface IMarketplaceNotificationStatus extends z.ZodType<MarketplaceNotificationStatus> {}
